import { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'jotai';
import { PhoneCallProvider } from './contexts/phoneCallHandlerContext/PhoneCallContext';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export const Providers = ({ children }: PropsWithChildren) => {
    return (
        <QueryClientProvider client={queryClient}>
            <Provider>
                <PhoneCallProvider>{children}</PhoneCallProvider>
            </Provider>
        </QueryClientProvider>
    );
};
